export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5612.64a9ca1e.jpg";